/**
 * 쿠키 세팅
 * @param  {String} name 쿠키이름
 * @param  {String} value 쿠키값
 * @param  {Number} expiredays 만료날짜
 * @example
 * setCookie('topBanner', 'show', 1);
 */
export const setCookie = (name = '', value = '', expiredays = 1, domain) => {
    let todayDate = new Date();
    todayDate.setDate(todayDate.getDate() + expiredays);


    // expiredays가 0이면 session 쿠키가 만들어짐

    if(expiredays === 0){
        document.cookie = `${name}=${escape(value)}; path=/; SameSite=Lax;; domain=${domain ? domain : ''}`;
    }else{
        document.cookie = `${name}=${escape(value)}; path=/; expires=${todayDate.toGMTString()};SameSite=Lax;; domain=${domain ? domain : ''}`;
    }
};

/**
 * 쿠키 확인
 * @param  {String} name 쿠키이름
 * @returns {String}
 * @example
 * getCookie('topBanner') == 'show' // true : 쿠키가 입력 되어 있는 상태
 */
export const getCookie = (name = '') => {
    let cookies = document.cookie;
    if (cookies.indexOf(name) == -1) return false;
    let cookie = cookies.substr(cookies.indexOf(name));
    cookie = cookie.split(';')[0];
    cookie = cookie.substr(cookie.indexOf('=') + 1);
    return cookie;
};

